<div class="event-list">
    <upsc-calendar-month-scroller (monthSelected)="onMonthSelected($event)"></upsc-calendar-month-scroller>

    <ul class="event-items">
        <upsc-event-item *ngFor="let item of displayedItems" [item]="item"></upsc-event-item>
    </ul>
</div>
